<template>
    <div>
        <manage-header></manage-header>
        <div class="head xy-center">
            <img :src="require('@/assets/img/defaulteActor.png')" alt="" />
            <div style="margin-left: 10px">
                <div class="font-size18 c-fff">
                    Hi,{{ $store.state.userInfo.UserName }}
                </div>
                <div class="organ-name">
                    {{ $store.state.userInfo.OrganName }}
                </div>
            </div>
        </div>
        <div class="body wrapper" style="width: 65%">
            <slot/>
        </div>
    </div>
</template>

<script>
import ManageHeader from "@/components/manager/ManageHeader";
import { isEmpty } from "@/utils";

export default {
    name: "ManageWrapper",
    components: { ManageHeader },
    computed: {
        routes() {
            if (isEmpty(this.$router.adminRoutes)) {
                return []
            }
            /**
             * 筛除 meta.hidden == true 的路由
             * @param list 路由数组
             * @return {[]} 新路由数组
             */
            function filterHide(list) {
                let result = []
                list.forEach(el => {
                    if (!el.meta.hidden) {
                        if (el.children && el.children.length > 0) {
                            let _el = Object.assign({}, el)
                            _el.children = filterHide(_el.children)
                            result.push(_el)
                        } else {
                            result.push(el)
                        }
                    }
                })
                return result;
            }
            return filterHide(this.$router.adminRoutes[0].children);
        },
        keepAlive () {
            return this.$route.meta?.alive
        }
    },
};
</script>

<style scoped lang="less">
@import "../../styles/manage";
.head {
    box-sizing: border-box;
    padding-bottom: 60px;
    margin-top: 70px;
    height: 200px;
    background: url("../../assets/img/admin/admin-head.png");
    img {
        width: 60px;
        height: 60px;
    }
    .organ-name {
        font-size: 14px;
        color: #ffffff;
        margin-top: 10px;
    }
}
.body {
    margin: -60px auto 60px auto;
}
.wrapper {
    background-color: #FFF;
    border-radius: 8px;
    padding: 30px;
}
</style>
